import React from 'react'
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import logo from '../assets/logo.png'

export default function NavigationBar() {
    return (
        <div>
            <Navbar expand="lg" bg="light" data-bs-theme="light">
                <Container>
                    <Navbar.Brand href="/">
                        <img src={logo} style={{
                            width: "120px"
                        }} />
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto">
                            <Nav.Link href="/">Home</Nav.Link>
                            <Nav.Link href="/privacy-policy">Privacy Policy</Nav.Link>
                            {/* <Nav.Link href="/refund-policy">Refund Policy</Nav.Link>
                            <Nav.Link href="/Terms-and-condition">Terms & Condition</Nav.Link> */}
                            <Nav.Link href="/contact">Contact</Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </div>
    )
}
